import { render, staticRenderFns } from "./block-receipt-text-view.vue?vue&type=template&id=c587ffb6&scoped=true&lang=pug&"
import script from "./block-receipt-text-view.vue?vue&type=script&lang=js&"
export * from "./block-receipt-text-view.vue?vue&type=script&lang=js&"
import style0 from "./block-receipt-text-view.vue?vue&type=style&index=0&id=c587ffb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c587ffb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
